import React, { useState, useEffect } from "react";
import axios from "axios";
import routes from "../../app/routes";
import Table from "./Table";

export default function Index({ fileImportId, title, importType }) {
  const [collection, setCollection] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const updateCollection = () => {
    setLoaded(true);
    axios
      .get(routes.api.file_import_items.list, {
        params: { file_import_id: fileImportId },
      })
      .then((resp) => {
        setCollection(resp.data.data);
        setLoaded(false);
      });
  };

  useEffect(() => {
    updateCollection();
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h2>{title}</h2>
        </div>
      </div>
      <div>
        {loaded && <p className="text-center mt20">Processing...</p>}
        {!loaded && <Table collection={collection} importType={importType} />}
      </div>
    </>
  );
}
